import momentJalaali from "moment-jalali";
import { faList, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { getCardSubProducts, deleteSubProduct, addOrUpdateSubProduct, getCardSubProductsWithSerial } from "../store/api/GuaranteeApi";
import BihamtaTable from "../../Components/BihamtaTable";
import { Check2Square, CheckLg, DashCircle, ExclamationTriangle, List, PlusSquare } from "react-bootstrap-icons";
import ModalProducts from "../../Components/Modals/ModalProducts";
import DatePicker from "react-datepicker2";
import { setDialog } from "../store/api/GetAllProduct";
import { getJalaliDiff,  setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

const ModalGuaranteeSubProducts = (props) => {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const isMobile = useIsMobileApp();
    const { show, cardID, productName, productModel, serialNumber, cardNo, productGrouppingType, onSelect } = popData;
    const [popProduct, setPopProduct] = useState({ show: false });
    const [currentSub, setCurrentSub] = useState();
    const [subProducts, setSubProductList] = useState(null);
    const [submitError, setSubmitError] = useState(null);
    const subProductsCol = [
        { colTitle: "مارک قطعه", colName: "ProductHolderName" },
        { colTitle: "نام/نوع قطعه", colName: "ProductName" },
        { colTitle: "مدل قطعه", colName: "ProductModel" },
        { colTitle: "شماره سریال", colName: "SerialNumber", style:{fontFamily:"Dark-Sans", fontSize:"11.5px"} },
        { colTitle: "آغاز گارانتی", colName: "PGuaranteeStartDate" },
        { colTitle: "پایان گارانتی", colName: "PGuaranteeEndDate" },
        { colTitle: "فعال", colName: "IsActive", colType: "boolean" },
        {colTitle:"شرح", colName:"Description"}
    ]
    const rowButtons = [
        {
            type: "delete", title: "حذف گارانتی", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف گارانتی',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteSub(item)
                }))
            },
            showCondition: (row) => row.IsActive && !onSelect
        },
        { type: "common", title: "انتخاب", icon: <Check2Square size={18} color="blue" className="rowBtn"/>, onclick: rowClick, showCondition: () => isMobile && onSelect !== undefined }
    ]
    function close() {
        setPopData({ show: false });
        setCurrentSub();
    }
    function prepareForAdd() {
        setCurrentSub({ ID: 0 });
    }
    function selectCurrentSub(row) {
        delete row.e;
        setCurrentSub(row);
    }
    function deleteSub(row) {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف گارانتی");
            }
            else {
                getCardSubProducts(cardID, setSubProductList);
            }
        }
        deleteSubProduct(row.ID, onSuccess);
    }
    function showModalProduct() {
        const onSetData = (data) => {
            if (data?.ProductID) {
                setCurrentSub({
                    ...currentSub,
                    HolderName: data.HolderName,
                    ProductID: data.ProductID,
                    ProductCode: data.ProductCode,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel
                })
            }

        }
        setPopProduct({
            show: true,
            setProductData: onSetData
        })
    }
    function cancelCurrent() {
        setSubmitError(null);
        setCurrentSub();
    }
    function addMonth(month) {
        if (currentSub.GuaranteeStartDate && currentSub.GuaranteeStartDate !== '') {
            const m = momentJalaali(currentSub.GuaranteeStartDate);
            const endDt = m.add("jMonth", Number(month));
            currentSub.GuaranteeTimeInMonth = month;
            setCurrentSub({ ...currentSub, GuaranteeEndDate: endDt.local("en").format("YYYY-MM-DD") });

        }
    }
    function calcG_TimeInMonth(date, isEnd) {
        if (isEnd) {
            currentSub.GuaranteeEndDate = date;
        }
        else {
            currentSub.GuaranteeStartDate = date;
        }
        const gStartDate = currentSub.GuaranteeStartDate;
        const gEndDate = currentSub.GuaranteeEndDate;
        if ((isEnd && (!gStartDate || gStartDate === '')) || (!isEnd && (!gEndDate || gEndDate === ''))) {
            return;
        }
        const result = getJalaliDiff(gStartDate, gEndDate);
        // const endDate = isEnd ? new Date(date) : new Date(gEndDate);
        // const startDate = isEnd ? new Date(gStartDate) : new Date(date);
        // let months = endDate.getMonth() - startDate.getMonth()
        //     + (12 * (endDate.getFullYear() - startDate.getFullYear()));

        // if (endDate.getDate() < startDate.getDate()) {
        //     months--;
        // }
        setCurrentSub({ ...currentSub, GuaranteeTimeInMonth: result.months });

    }
    function onSubmitSub() {
        setSubmitError(null);
        if (!currentSub.ProductID) {
            setSubmitError("قطعه ای انتخاب نشده است");
            return;
        }
        if (!currentSub.SerialNumber) {
            setSubmitError("شماره سریال وارد نشده است");
            return;
        }
        if (!currentSub.GuaranteeStartDate) {
            setSubmitError("تاریخ آغاز گارانتی وارد نشده است");
            return;
        }
        if (!currentSub.GuaranteeEndDate) {
            setSubmitError("تاریخ پایان گارانتی وارد نشده است");
            return;
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setSubmitError(res.Error);
            }
            else {
                getCardSubProducts(cardID, setSubProductList);
                setCurrentSub();
            }
        }
        currentSub.GuaranteeID = cardID;
        addOrUpdateSubProduct(currentSub, onSuccess);
    }
    function rowClick(row) {
        setSubmitError(null);
        if (!row.IsActive) {
            setSubmitError("این ردیف قابل انتخاب نیست");
            return;
        }
        delete row.e;
        onSelect?.(row);
        close();
    }
    useEffect(() => {
        if (show) {
            if (Number(cardID) > 0) {
                getCardSubProducts(cardID, setSubProductList);
            }
            else if (cardNo?.length > 0 && serialNumber?.length > 0) {
                getCardSubProductsWithSerial(serialNumber, cardNo, setSubProductList);
            }
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }} size="xl">
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType} defaultSalePrice=""
                defaultSalePriceLabel="" defaultStorages="" />
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faList} size="lg" />&nbsp;
                    فهرست قطعات [{productName}][{productModel}][{serialNumber}]
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {currentSub &&
                    <Row className="rowBorder" style={{ padding: 5 }}>
                        {submitError &&
                            <Alert variant="danger">
                                <ExclamationTriangle size={18} />&nbsp;
                                {submitError}
                                <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={e => setSubmitError(null)} />
                            </Alert>
                        }
                        <table>
                            <thead>
                                <th>مشخصات قطعه</th>
                                <th>شماره سریال</th>
                                <th>آغاز گارانتی</th>
                                <th>مدت گارانتی</th>
                                <th>پایان گارانتی</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div>
                                            <input className="tableRowInput" value={currentSub.ProductName ? (currentSub.HolderName ? currentSub.HolderName + "-" : "") + currentSub.ProductName + "-" + currentSub.ProductModel : ""} readOnly />
                                            <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={showModalProduct}><List size={15} /></Button>
                                        </div>
                                    </td>
                                    <td style={{fontFamily:"Dark-Sans", fontSize:"11.5px"}}><input className="tableRowInput" onChange={e => currentSub.SerialNumber = e.target.value} /></td>
                                    <td><DatePicker className="tableRowInput mt-0" isGregorian={false} timePicker={false} onChange={val => setCurrentSub({ ...currentSub, GuaranteeStartDate: val.local("en").format("YYYY-MM-DD") })} /></td>
                                    <td><input type="number" className="tableRowInput" onChange={e => addMonth(e.target.value)} value={currentSub.GuaranteeTimeInMonth ?? 0} /></td>
                                    <td><DatePicker className="tableRowInput mt-0" isGregorian={false} timePicker={false} value={currentSub.GuaranteeEndDate ? momentJalaali(currentSub.GuaranteeEndDate) : null} onChange={val => calcG_TimeInMonth(val.local("en").format("YYYY-MM-DD"), true)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="mt-1">
                            <Button variant="success" className="group-Btn" onClick={onSubmitSub}><CheckLg size={17} />&nbsp;ثـبت</Button>
                            <Button variant="danger" className="group-Btn" onClick={cancelCurrent}><DashCircle size={17} />&nbsp;انصراف</Button>
                        </div>
                    </Row>
                }
                {!currentSub && !onSelect && <Button className="group-Btn-smalll" onClick={prepareForAdd}><PlusSquare size={18} /></Button>}
                <BihamtaTable columns={subProductsCol} dataList={subProducts} rowButtons={rowButtons} rowClick={rowClick}/>
            </Modal.Body>
        </Modal>
    )

}
export default ModalGuaranteeSubProducts;